var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "382.000000pt",
    height: "317.000000pt",
    viewBox: "0 0 382.000000 317.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,317.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252 3030 c-65 -40 -62 27 -62 -1242 0 -1078 1 -1155 18 -1187 9 -19 30 -44 45 -55 28 -21 39 -21 683 -24 l654 -2 0 -120 0 -120 -189 0 c-175 0 -190 -1 -215 -21 -31 -24 -35 -68 -8 -92 17 -15 78 -17 665 -17 634 0 647 0 667 20 27 27 25 56 -5 85 -24 25 -26 25 -215 25 l-190 0 0 120 0 120 643 0 c709 0 683 -2 731 63 21 28 21 31 21 1200 0 1102 -1 1174 -18 1204 -36 68 85 63 -1634 63 -1545 0 -1558 0 -1591 -20z m3116 -1242 l-3 -1133 -1520 0 -1520 0 -3 1133 -2 1132 1525 0 1525 0 -2 -1132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 1962 l-207 -207 210 -210 210 -210 50 50 50 50 -155 155 c-85 85 -155 159 -155 163 0 4 68 75 150 158 83 83 150 154 150 158 0 4 -21 28 -48 54 l-47 47 -208 -208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435 2120 l-50 -50 160 -160 160 -160 -158 -158 -157 -157 50 -50 50 -50 208 208 207 207 -210 210 -210 210 -50 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570 1410 l0 -70 275 0 275 0 0 70 0 70 -275 0 -275 0 0 -70z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.2d9e641caa015ed8086280ba9bf7b6d3.svg";
export { ForwardRef as ReactComponent };